// extracted by mini-css-extract-plugin
export var avatar = "_o2-3";
export var avatarContainer = "_o2-2";
export var avatarSpacer = "_o2-5";
export var avatarSpacerContainer = "_o2-4";
export var avatarStackContainer = "_o2-1";
export var bubble = "_o2-0";
export var remainderBubble = "_o2-6";